import { render, staticRenderFns } from "./Selections3.vue?vue&type=template&id=81ffe002&"
import script from "./Selections3.vue?vue&type=script&lang=js&"
export * from "./Selections3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports